import React, { useState, useRef, useEffect } from 'react';
import s from './s.module.less';

type RangeValue = 'LAST_7D' | 'LAST_30D' | 'LAST_90D' | 'YEAR_TO_DATE';
type FutureRangeValue = 'NEXT_7D' | 'NEXT_30D' | 'NEXT_90D';

type PastOption = { label: string; value: RangeValue };
type FutureOption = { label: string; value: FutureRangeValue };

const PAST_OPTIONS: PastOption[] = [
    { label: 'Last 7 days', value: 'LAST_7D' },
    { label: 'Last 30 days', value: 'LAST_30D' },
    { label: 'Last 90 days', value: 'LAST_90D' },
    { label: 'Year to date', value: 'YEAR_TO_DATE' },
];

const FUTURE_OPTIONS: FutureOption[] = [
    { label: 'Next 7 days', value: 'NEXT_7D' },
    { label: 'Next 30 days', value: 'NEXT_30D' },
    { label: 'Next 90 days', value: 'NEXT_90D' },
];

type Props = {
    value: string;
    onChange: (value: string) => void;
    mode?: 'past' | 'future';
};

const RangeDropdown: React.FC<Props> = ({ value, onChange, mode = 'past' }) => {
    const [open, setOpen] = useState(false);
    const ref = useRef<HTMLDivElement>(null);

    const options = mode === 'future' ? FUTURE_OPTIONS : PAST_OPTIONS;
    const current = options.find((o) => o.value === value);

    useEffect(() => {
        const handleClick = (e: MouseEvent) => {
            if (ref.current && !ref.current.contains(e.target as Node)) {
                setOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClick);
        return () => document.removeEventListener('mousedown', handleClick);
    }, []);

    return (
        <div className={`${s.wrap} ${open ? s.open : ''}`} ref={ref}>
            <span className={s.btn} onClick={() => setOpen(!open)}>
                <span className={s.label}>{current?.label ?? value}</span>
                <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" width="16" height="16">
                    <polyline points="4 6 8 10 12 6" />
                </svg>
            </span>
            {open && (
                <div className={s.list}>
                    {options.map((opt) => (
                        <span
                            key={opt.value}
                            className={`${s.item} ${opt.value === value ? s.active : ''}`}
                            onClick={() => {
                                onChange(opt.value);
                                setOpen(false);
                            }}
                        >
                            {opt.label}
                            {opt.value === value && ' ✓'}
                        </span>
                    ))}
                </div>
            )}
        </div>
    );
};

export default RangeDropdown;
